import { render, staticRenderFns } from "./wentilv.vue?vue&type=template&id=b56e549e&scoped=true"
import script from "./wentilv.vue?vue&type=script&lang=js"
export * from "./wentilv.vue?vue&type=script&lang=js"
import style0 from "./wentilv.vue?vue&type=style&index=0&id=b56e549e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56e549e",
  null
  
)

export default component.exports